import { render, staticRenderFns } from "./xmymap.vue?vue&type=template&id=cfc046a2&scoped=true&"
import script from "./xmymap.vue?vue&type=script&lang=js&"
export * from "./xmymap.vue?vue&type=script&lang=js&"
import style0 from "./xmymap.vue?vue&type=style&index=0&id=cfc046a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc046a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfc046a2')) {
      api.createRecord('cfc046a2', component.options)
    } else {
      api.reload('cfc046a2', component.options)
    }
    module.hot.accept("./xmymap.vue?vue&type=template&id=cfc046a2&scoped=true&", function () {
      api.rerender('cfc046a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/granary/map/newMap/xmymap.vue"
export default component.exports